import Vue from 'vue';

import Checkbox from './Checkbox.vue';
import TextField from './TextField.vue';
import Button from './Button.vue';
import Snackbar from './Snackbar.vue';
import Icon from './Icon.vue';
import Select from './Select.vue';
import StepProgressBar from './StepProgressBar.vue';
import Tab from './Tab.vue';
import TextArea from './TextArea.vue';
import TreeSelect from './TreeSelect.vue';

Vue.component(Checkbox.name, Checkbox);
Vue.component(TextField.name, TextField);
Vue.component(Button.name, Button);
Vue.component(Snackbar.name, Snackbar);
Vue.component(Icon.name, Icon);
Vue.component(Select.name, Select);
Vue.component(StepProgressBar.name, StepProgressBar);
Vue.component(Tab.name, Tab);
Vue.component(TextArea.name, TextArea);
Vue.component(TreeSelect.name, TreeSelect);
